const o = {
  beforeMount(e, t) {
    e._handler = (n) => {
      !e.contains(n.target) && t.value && t.value(n);
    }, document.body.addEventListener("click", e._handler);
  },
  unmounted(e) {
    document.body.removeEventListener("click", e._handler);
  }
};
export {
  o as default
};
//# sourceMappingURL=clickoutside.js.map
